import { Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ManualInfo = ({ kyb }) => {
  const { t } = useTranslation(['common'])
  if (!kyb) return null

  return (
    <>
      <Paper elevation={0} variant="colorPrimary">
        {t('common:manualData')}
      </Paper>

      <Paper
        variant="rootOutlined"
        elevation={0}
        style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '.75rem' }}
      >
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:cluster')}</Typography>
          <Typography variant="subtitle3">{kyb.cluster ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:clientTypes')}</Typography>
          <Typography variant="subtitle3">{kyb.clientTypes ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:products')}</Typography>
          <Typography variant="subtitle3">{kyb.products ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:businessSegments')}</Typography>
          <Typography variant="subtitle3">{kyb.businessSegments ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:site')}</Typography>
          <Typography variant="subtitle3">{kyb.site ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:legalRepresentative')}</Typography>
          <Typography variant="subtitle3">
            {kyb?.legalRepresentativeLabel || kyb.legalRepresentative || '---'}
          </Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:legalRepresentativeDocumentNumber')}</Typography>
          <Typography variant="subtitle3">
            {kyb.legalRepresentativeDocumentNumber || kyb.legalRepresentative?.documentNumber || '---'}
          </Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:legalRepresentativeEmail')}</Typography>
          <Typography variant="subtitle3">
            {kyb.legalRepresentativeEmail || kyb.legalRepresentative?.email || '---'}
          </Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:legalRepresentativePhone')}</Typography>
          <Typography variant="subtitle3">
            {kyb.legalRepresentativePhone || kyb.legalRepresentative?.phone || '---'}
          </Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:tpv')}</Typography>
          <Typography variant="subtitle3">{kyb.tpv ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">{t('common:monthlyQty')}</Typography>
          <Typography variant="subtitle3">{kyb.monthlyQty ?? '---'}</Typography>
        </div>
        <div className="c-detail-row">
          <Typography variant="subtitle1">Google Drive Url</Typography>
          <Typography variant="subtitle3">{kyb.externalUrl1 ?? '---'}</Typography>
        </div>

        {kyb.metadata && (
          <div className="c-detail-col">
            <Typography variant="subtitle1">Metadata</Typography>
            <ul>
              {Object.entries(kyb.metadata).map(([key, value]) => (
                <li key={key}>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">{key ?? '---'}</Typography>
                    <Typography variant="subtitle3">{value ?? '---'}</Typography>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Paper>
    </>
  )
}

export default ManualInfo
